import { lazyRetry } from '@bimser/core';
import { lazy, Suspense } from 'react';
import BCErrorBoundary from '../BCErrorBoundary';
import * as BCExtremeGridActionCreators from './actions';
import * as ActionTypes from './actionTypes';
import * as BCExtremeGridEntities from './entities';
import getFilters from './helpers/getFilters';
import getSortingColumns from './helpers/getSortingColumns';
import Reducer from './reducers';

const ReactiveGridStateful = lazy(() =>
	lazyRetry(() =>
		import(/* webpackChunkName: "grid" */ './Stateful').then(module => ({
			default: module.default
		}))
	)
);
const ReactiveGridStateless = lazy(() =>
	lazyRetry(() =>
		import(/* webpackChunkName: "grid" */ './BCExtremeGridWithSelectors').then(module => ({
			default: module.default
		}))
	)
);

function BCExtremeGridStateful(props: BCExtremeGridEntities.IStatefulExtremeGridProps) {
	return (
		<BCErrorBoundary>
			<Suspense fallback={<div></div>}>
				<ReactiveGridStateful {...props} />
			</Suspense>
		</BCErrorBoundary>
	);
}
function BCExtremeGridStateless(props: BCExtremeGridEntities.IExtremeGridProps) {
	return (
		<BCErrorBoundary>
			<Suspense fallback={<div></div>}>
				<ReactiveGridStateless {...props} />
			</Suspense>
		</BCErrorBoundary>
	);
}
BCExtremeGridStateful.Core = BCExtremeGridStateless;

export default BCExtremeGridStateful;

const BCExtremeGridHelpers = {
	getSortingColumns: getSortingColumns,
	getFilters: getFilters
};

const BCExtremeGridConsts = {
	defaultPageSize: 10
};

export {
	BCExtremeGridActionCreators,
	ActionTypes as BCExtremeGridActionTypes,
	BCExtremeGridConsts,
	BCExtremeGridEntities,
	BCExtremeGridHelpers,
	Reducer as BCExtremeGridReducer
};
